import React from "react";

function Footer() {
  return (
    <footer className="border-t pt-4 mt-8 text-sm text-center text-gray-500">
      <p>Liên hệ: support@leventshop.vn | Địa chỉ: 123 Đường ABC, Quận Long Biên, TP.HN</p>
      <p>&copy; 2025 leventshop. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
